import { useState } from 'react'
import { useAdmin } from '../context/AdminContext'

const Login = () => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  })
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  
  const { login } = useAdmin()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    setError('')
    setSuccess('')

    try {
      const result = await login(credentials.username, credentials.password)
      
      if (result.success) {
        setSuccess('Login successful! Welcome to SSP Biotech Admin Panel.')
      } else {
        setError(result.message || 'Login failed')
      }
    } catch (error) {
      setError('An error occurred during login')
    } finally {
      setIsLoading(false)
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setCredentials(prev => ({
      ...prev,
      [name]: value
    }))
  }

  return (
    <div className="login-container">
      <div className="login-card fade-in">
        <div className="login-header">
          <div className="login-logo">🏢</div>
          <h1 className="login-title">Admin Panel</h1>
          <p className="login-subtitle">
            Welcome to <span className="company-name">SSP Biotech</span> Administration
          </p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username" className="form-label">
              👤 Username
            </label>
            <input
              type="text"
              id="username"
              name="username"
              value={credentials.username}
              onChange={handleInputChange}
              className="form-input"
              placeholder="Enter your username"
              required
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              🔐 Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleInputChange}
              className="form-input"
              placeholder="Enter your password"
              required
              autoComplete="current-password"
            />
          </div>

          {error && (
            <div className="error-message">
              ⚠️ {error}
            </div>
          )}

          {success && (
            <div className="success-message">
              ✅ {success}
            </div>
          )}

          <button 
            type="submit" 
            className="login-btn"
            disabled={isLoading}
          >
            {isLoading ? (
              <>🔄 Authenticating...</>
            ) : (
              <>🚀 Access Admin Panel</>
            )}
          </button>
        </form>

        <div className="login-footer">
          <p style={{ 
            marginTop: '2rem', 
            textAlign: 'center', 
            color: 'var(--text-tertiary)', 
            fontSize: '0.85rem' 
          }}>
            🔒 Secure Admin Access • admin.sspbiotech.in
          </p>
        </div>
      </div>
    </div>
  )
}

export default Login
